export const enum AppPlatform {
  ios,
  android,
  desktop,
}
let _appPlatform: AppPlatform | null = null;

export const detectPlatform = () => {
  if (_appPlatform) {
    return _appPlatform;
  }
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  // Check for iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    _appPlatform = AppPlatform.ios;
    return AppPlatform.ios;
  }

  // Check for Android
  if (/android/i.test(userAgent)) {
    _appPlatform = AppPlatform.android;
    return AppPlatform.android;
  }

  // Otherwise, assume Desktop
  _appPlatform = AppPlatform.desktop;
  return AppPlatform.desktop;
};
